import Vue from "vue";

export const ProductLabelEventBus = new Vue();
